import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftOrderDetailResponse } from '@models/gift';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import styles from './styles.module.scss';

interface Props {
    response: GiftOrderDetailResponse;
}
function Complete({ response }:Props) {
    const { t } = useTranslation('gift');
    const ref = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLImageElement>(null);
    const imageUrl = response?.detail.giftItem.imageUrl;
    useCompleteAnimation({ ref, cardRef });
    return (
        <div className={styles.container}
            ref={ref}>
            <div className={styles.cardWrapper}>
                <Image src={imageUrl}
                    width={300}
                    height={200}
                    ref={cardRef}
                    className={styles.card}
                    alt={t('giftOrderComplete.cardImageAlt')} />
            </div>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    {t('giftOrderComplete.completeMessage')}
                </Text>
            </Column>
        </div>
    );
}

export default Complete;
